import { useState } from 'react'
import { X, Sparkles, Check } from 'lucide-react'

// A small, once-only "first time on this page" tip. Brief and skippable.
// Remembers per browser via localStorage, keyed by `id`.
export default function PageTip({ id, title, points = [], note }) {
  const key = `okoiya_tip_${id}`
  const [show, setShow] = useState(() => {
    try { return localStorage.getItem(key) !== '1' } catch { return true }
  })
  function dismiss() {
    try { localStorage.setItem(key, '1') } catch { /* ignore */ }
    setShow(false)
  }
  if (!show) return null

  return (
    <div style={{ position: 'relative', background: 'linear-gradient(135deg,#FBF4EE,#F6EFE8)', border: '1px solid rgba(196,130,106,0.25)', borderRadius: '1rem', padding: '1rem 1.125rem' }}>
      <button onClick={dismiss} aria-label="Dismiss tip" style={{ position: 'absolute', top: 10, right: 10, background: 'none', border: 'none', cursor: 'pointer', color: '#BCBCBC', padding: 2 }}>
        <X size={15} />
      </button>

      <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom: '0.4rem' }}>
        <Sparkles size={14} color="#C4826A" />
        <span style={{ fontFamily: 'Nunito Sans, sans-serif', fontSize: '0.62rem', fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#C4826A' }}>Quick tip</span>
      </div>

      <p style={{ fontFamily: 'Gibs, serif', fontWeight: 400, fontSize: '1.05rem', color: '#1A1A1A', margin: '0 0 0.5rem' }}>{title}</p>

      <ul style={{ margin: '0 0 0.75rem', padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
        {points.map((p, i) => (
          <li key={i} style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start', fontFamily: 'Nunito Sans, sans-serif', fontSize: '0.82rem', color: '#5A5048', lineHeight: 1.55 }}>
            <span style={{ color: '#9BAF9B', fontWeight: 700, flexShrink: 0 }}>•</span>
            <span>{p}</span>
          </li>
        ))}
      </ul>

      {note && <p style={{ fontFamily: 'Nunito Sans, sans-serif', fontSize: '0.72rem', color: '#9B9B9B', margin: '0 0 0.75rem', lineHeight: 1.5 }}>{note}</p>}

      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', justifyContent: 'flex-end' }}>
        <button onClick={dismiss} style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'Nunito Sans, sans-serif', fontSize: '0.78rem', color: '#9B9B9B', padding: 0 }}>Skip</button>
        <button onClick={dismiss} className="btn-primary" style={{ fontSize: '0.78rem', padding: '0.45rem 1rem', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
          <Check size={13} /> Got it
        </button>
      </div>
    </div>
  )
}
